
<template>
  <div>
    <div class="count-down">
      <div class="count-down__content">
        <div class="count-down__item count-down__content--day">{{ day }}</div>
        <div class="count-down__item count-down__content--hour">{{ hour }}</div>
        <div class="count-down__item count-down__content--minute">
          {{ minute }}
        </div>
        <div class="count-down__item count-down__content--second">
          {{ second }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { countDown } from '../../utils/countDown';

@Component({})
export default class CountDown extends Vue {
  @Prop({ default: 0 }) count!: number;

  timer: any = null;
  day = '00';
  hour = '00';
  minute = '00';
  second = '00';

  mounted() {
    if (this.count) {
      this.start();
    }
  }

  beforeDestroy() {
    this.stop();
  }

  start() {
    this.timer = countDown(
      {
        count: this.count * 1000,
        interval: 1000,
      },
      ({ day, minute, second, hour }) => {
        this.day = `${day}`;
        this.hour = `${hour}`;
        this.minute = `${minute}`;
        this.second = `${second}`;
        if (!Number(this.day) && !Number(this.hour) && !Number(this.minute) && !Number(this.second)) {
          this.stop();
          this.$emit('stopCount');
        }
      }
    );
  }

  stop() {
    this.timer && this.timer.stop();
  }
}
</script>

<style lang="scss" scoped>
.count-down {
  position: absolute;
  right: 0;
  bottom: 56px;
  left: 0;
  height: 70px;

  &__content {
    position: relative;
    width: 100%;
    height: 100%;

    &--day {
      left: 67px;
    }

    &--hour {
      left: 217px;
    }

    &--minute {
      left: 392px;
    }

    &--second {
      left: 568px;
    }
  }

  &__item {
    position: absolute;
    top: 0;
    bottom: 0;
    padding-top: 2px;
    color: white;
    font-weight: bold;
    font-size: 60px;
    font-family: DINAlternate-Bold, DINAlternate;
    letter-spacing: 29px;
  }
}
</style>